{
  "title": "Dev",
  "UI": {
    "title": "UI"
  },
  "createDeviceActionSchedule": {
    "title": "Create Device Action Schedule"
  },
  "schedulesView": {
    "title": "Schedules"
  },
  "alertsDemo": {
    "alerts": "Alerts",
    "linkTo": "Alerts Demo",
    "showTitleCheckbox": "Title",
    "title": "Alerts Demo"
  },
  "buttonsDemo": {
    "actionButtons": "Action Buttons {{direction}}",
    "title": "Buttons Demo"
  },
  "devLanding": {
    "linkTo": "dev-landing",
    "title": "Dev Landing"
  },
  "fontDemo": {
    "italic": "Italic",
    "linkTo": "font-demo",
    "regular": "Regular",
    "subheader": "Secondary Heading",
    "title": "Font Demo"
  },
  "linkTo": "Dev",
  "scratch": {
    "linkTo": "scratch",
    "title": "Scratch"
  }
}
